import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'convfact-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    standalone: false
})

export class NotFoundComponent {

    constructor(private router: Router) { }

    goToLogin() {
        this.router.navigate(['/login']);
    }
}
